// Build-time flag hiding the in-progress Activity page.
// Follow-up: replace with tenant-scoped application configuration before GA.
export const IS_ACTIVITY_DASHBOARD_ENABLED = import.meta.env.VITE_ACTIVITY_DASHBOARD === 'true'
